export const SUBMITTED_AT_WINDOW_MINUTES = parseInt(process.env['REACT_APP_SUBMITTED_AT_WINDOW_MINUTES'] || '120');
